export default abstract class HasLabel {
    getLabel(): string {
        return this.toString();
    }

    abstract toString(): string;
}
